<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>{{ presupuesto.id != null ? 'P' : 'Crear p' }}resupuesto #{{ presupuesto.id }}</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <v-tabs :scrollable="false" v-model="tab">
                        <v-tab>Datos</v-tab>
                        <v-tab v-if="presupuesto.id != null">Archivos</v-tab>
                        <v-tab v-if="presupuesto.id != null">Dibujar</v-tab>
                        <v-tab v-if="presupuesto.id != null">Cálculos</v-tab>
                        <v-tab v-if="presupuesto.id != null">Facturas</v-tab>
                        <v-tab v-if="presupuesto.id != null">Órdenes</v-tab>
                        <v-row justify="end">
                            <v-tooltip right style="margin-bottom: 5px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        small
                                        :to="$route.meta.lista"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="blue"
                                        class="mt-4 mx-3"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-arrow-left-bold-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Volver</span>
                            </v-tooltip>
                        </v-row>
                        <v-tab-item>
                            <v-form ref="form" class="mt-3">
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <v-row dense>
                                        <v-col cols="12" md="6">
                                            <h3>Datos del presupuesto</h3>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            v-if="presupuesto.creador != null"
                                            style="
                                                text-align: right;
                                                color: gray;
                                            "
                                        >
                                            <h4>
                                                Creado por:{{
                                                    presupuesto.creador.name
                                                }}
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols=" 12"
                                            :md="presupuesto.id != null ? 2 : 4"
                                            v-if="rol == 1"
                                        >
                                            <v-checkbox
                                                label="Editable en ejecución"
                                                v-model="presupuesto.editable"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <clienteSelectVue
                                                v-model="presupuesto.id_cliente"
                                                label="Cliente"
                                                :extra="clientela"
                                                :rol="$route.meta.rol"
                                                :readonly="readonly"
                                            >
                                            </clienteSelectVue>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="4"
                                            v-if="presupuesto.id != null"
                                        >
                                            <v-autocomplete
                                                :readonly="readonly"
                                                v-model="presupuesto.id_estado"
                                                :rules="required_val"
                                                label="Estado"
                                                :items="estados"
                                                item-text="nombre"
                                                item-value="id"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <date-select
                                                v-model="presupuesto.fecha"
                                                label="Fecha de creación"
                                                :readonly="readonly"
                                                :rules="required_val"
                                            >
                                            </date-select>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <date-select
                                                v-model="
                                                    presupuesto.fecha_resolucion
                                                "
                                                label="Fecha de resolución"
                                            >
                                            </date-select>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <date-select
                                                v-model="
                                                    presupuesto.fecha_incidencia
                                                "
                                                readonly
                                                label="Fecha de incidencia"
                                                :readonly="true"
                                            >
                                            </date-select>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <date-select
                                                v-model="
                                                    presupuesto.fecha_ejecucion
                                                "
                                                readonly
                                                label="Fecha de ejecución"
                                                :readonly="false"
                                            >
                                            </date-select>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <h3>Datos del cliente</h3>

                                    <DatosClientes
                                        v-model="presupuesto.clientela"
                                        :readonly="true"
                                    ></DatosClientes>
                                </v-card>
                                <v-card
                                    style="min-width: 100%; padding: 1rem"
                                    v-if="!readonly"
                                >
                                    <h3>Añadir línea</h3>
                                    <v-form ref="linea_form">
                                        <v-row>
                                            <v-col cols="6">
                                                <div style="display: flex">
                                                    <v-autocomplete
                                                        v-if="
                                                            linea.tipo_prod == 0
                                                        "
                                                        v-model="
                                                            linea.id_producto
                                                        "
                                                        :items="productos"
                                                        item-text="titulo"
                                                        item-value="id"
                                                        label="Producto"
                                                        :rules="required_val"
                                                    >
                                                    </v-autocomplete>
                                                    <v-text-field
                                                        v-else
                                                        v-model="linea.producto"
                                                        type="text"
                                                        label="Producto"
                                                        :rules="required_val"
                                                    >
                                                    </v-text-field>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="1">
                                                <div class="spacing">
                                                    <v-text-field-comma
                                                        v-model="linea.cantidad"
                                                        type="number"
                                                        label="Unidades"
                                                        :rules="required_val_0"
                                                    >
                                                    </v-text-field-comma>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="1">
                                                <div class="spacing">
                                                    <v-text-field-comma
                                                        v-model="linea.precio"
                                                        type="number"
                                                        label="Precio/Unidad"
                                                        :rules="required_val"
                                                    >
                                                    </v-text-field-comma>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="2">
                                                <div style="display: flex">
                                                    <v-text-field-comma
                                                        v-model="linea.dcto"
                                                        type="number"
                                                        label="Descuento"
                                                    >
                                                    </v-text-field-comma>
                                                    <v-btn-toggle
                                                        color="primary"
                                                        shaped
                                                        v-model="
                                                            linea.id_tipo_dcto
                                                        "
                                                        background-color="white"
                                                    >
                                                        <v-btn text>
                                                            <v-icon
                                                                >mdi-percent</v-icon
                                                            >
                                                        </v-btn>
                                                        <v-btn text>
                                                            <v-icon
                                                                >mdi-currency-eur</v-icon
                                                            >
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </div>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-btn
                                                    @click="openDescripcion"
                                                    :disabled="isloading"
                                                    color="success"
                                                    class="white--text"
                                                    >Añadir</v-btn
                                                >
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card>
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <h3>Líneas de presupuesto</h3>
                                    <v-row>
                                        <template>
                                            <v-col
                                                cols="12"
                                                v-for="producto in productos_lineas"
                                                v-bind:key="producto.id"
                                            >
                                                <template>
                                                    <h5>
                                                        {{ producto.nombre }}
                                                    </h5>
                                                    <v-data-table
                                                        dense
                                                        :headers="headers"
                                                        hide-default-footer
                                                        disable-pagination
                                                        :items="producto.lineas"
                                                        item-key="id"
                                                        class="elevation-1"
                                                    >
                                                        <template
                                                            v-slot:item.producto="{
                                                                item,
                                                            }"
                                                        >
                                                            <p
                                                                style="
                                                                    white-space: pre-line;
                                                                "
                                                            >
                                                                {{
                                                                    item.descripcion
                                                                }}
                                                            </p>
                                                        </template>
                                                        <template
                                                            v-slot:item.pvp="{
                                                                item,
                                                            }"
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    item.cantidad *
                                                                        item.precio
                                                                )
                                                            }}
                                                        </template>

                                                        <template
                                                            v-slot:item.dcto_unidad="{
                                                                item,
                                                            }"
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    item.dcto /
                                                                        item.cantidad
                                                                )
                                                            }}
                                                        </template>
                                                        <template
                                                            v-slot:item.cantidad="{
                                                                item,
                                                            }"
                                                        >
                                                            {{
                                                                item.cantidad
                                                                    | decimalComma
                                                            }}
                                                        </template>
                                                        <template
                                                            v-slot:item.precio="{
                                                                item,
                                                            }"
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    item.precio
                                                                )
                                                            }}
                                                        </template>
                                                        <template
                                                            v-slot:item.dcto="{
                                                                item,
                                                            }"
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    item.dcto
                                                                )
                                                            }}
                                                        </template>
                                                        <template
                                                            v-slot:item.total="{
                                                                item,
                                                            }"
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    item.total
                                                                )
                                                            }}
                                                        </template>
                                                        <template
                                                            v-slot:item.dcto_total="{
                                                                item,
                                                            }"
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    CalcularTotalDcto(
                                                                        item
                                                                    )
                                                                )
                                                            }}
                                                        </template>
                                                        <template
                                                            v-slot:item.action="{
                                                                item,
                                                            }"
                                                        >
                                                            <v-icon
                                                                @click="
                                                                    openEditDialog(
                                                                        item
                                                                    )
                                                                "
                                                                small
                                                                class="mr-2"
                                                                color="black"
                                                                style="
                                                                    font-size: 25px;
                                                                "
                                                                title="EDITAR"
                                                            >
                                                                mdi-pencil-outline
                                                            </v-icon>

                                                            <v-icon
                                                                @click="
                                                                    openDeleteDialog(
                                                                        item
                                                                    )
                                                                "
                                                                small
                                                                class="mr-2"
                                                                color="red"
                                                                style="
                                                                    font-size: 25px;
                                                                "
                                                                title="BORRAR"
                                                            >
                                                                mdi-trash-can
                                                            </v-icon>
                                                        </template>
                                                    </v-data-table>
                                                    <v-card
                                                        style="margin-top: 3rem"
                                                    >
                                                        <v-row>
                                                            <v-col cols="6">
                                                                <h4>
                                                                    Subtotal:
                                                                    {{
                                                                        formatPrice(
                                                                            CalcularSubTotales(
                                                                                presupuesto.lineas.filter(
                                                                                    (
                                                                                        element
                                                                                    ) =>
                                                                                        element.id_producto ==
                                                                                        producto.id
                                                                                )
                                                                            )
                                                                        )
                                                                    }}

                                                                    €
                                                                </h4>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </template>
                                            </v-col>
                                        </template>
                                    </v-row>
                                    <v-row align="start" justify="end">
                                        <v-col cols="12" md="8">
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field-comma
                                                        :readonly="readonly"
                                                        v-model="
                                                            presupuesto.mudanza
                                                        "
                                                        type="number"
                                                        label="Plataforma de mudanza"
                                                    >
                                                    </v-text-field-comma>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <div style="display: flex">
                                                        <v-text-field-comma
                                                            :readonly="readonly"
                                                            v-model="
                                                                presupuesto.dcto
                                                            "
                                                            type="number"
                                                            label="Descuento"
                                                        >
                                                        </v-text-field-comma>
                                                        <v-btn-toggle
                                                            :readonly="readonly"
                                                            color="primary"
                                                            shaped
                                                            v-model="
                                                                presupuesto.id_tipo_dcto
                                                            "
                                                            background-color="white"
                                                        >
                                                            <v-btn text>
                                                                <v-icon
                                                                    >mdi-percent</v-icon
                                                                >
                                                            </v-btn>
                                                            <v-btn text>
                                                                <v-icon
                                                                    >mdi-currency-eur</v-icon
                                                                >
                                                            </v-btn>
                                                        </v-btn-toggle>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <div style="display: flex">
                                                        <v-autocomplete
                                                            :readonly="readonly"
                                                            v-model="
                                                                presupuesto.iva
                                                            "
                                                            type="text"
                                                            label="IVA"
                                                            :items="ivas"
                                                            suffix="%"
                                                        >
                                                        </v-autocomplete>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-card
                                                style="
                                                    min-width: 100%;
                                                    padding: 1rem;
                                                "
                                            >
                                                <v-row>
                                                    <v-col cols="6">
                                                        <h4>Base imponible:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>
                                                            {{
                                                                formatPrice(
                                                                    calcularSubTotal()
                                                                )
                                                            }}

                                                            €
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="6">
                                                        <h4>Descuento:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>
                                                            -
                                                            {{
                                                                formatPrice(
                                                                    CalculateDescuento(
                                                                        presupuesto.subtotal
                                                                    )
                                                                )
                                                            }}

                                                            €
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="6">
                                                        <h4>Subtotal:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>
                                                            {{
                                                                formatPrice(
                                                                    calcularSubTotal() -
                                                                        this.CalculateDescuento()
                                                                )
                                                            }}

                                                            €
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                                <v-row
                                                    v-if="presupuesto.iva != 0"
                                                >
                                                    <v-col cols="6">
                                                        <h4>IVA:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>
                                                            {{
                                                                formatPrice(
                                                                    (calcularSubTotal() -
                                                                        this.CalculateDescuento()) *
                                                                        (Number.parseFloat(
                                                                            presupuesto.iva.toString()
                                                                        ) /
                                                                            100)
                                                                )
                                                            }}

                                                            €
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="6">
                                                        <h4>Total:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>
                                                            {{
                                                                formatPrice(
                                                                    presupuesto.total
                                                                )
                                                            }}

                                                            €
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-textarea
                                                :readonly="readonly"
                                                v-model="
                                                    presupuesto.observaciones
                                                "
                                                label="Obersevaciones"
                                                outlined
                                            >
                                            </v-textarea>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                :readonly="readonly"
                                                v-model="presupuesto.incidencia"
                                                label="Incidencia"
                                                outlined
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card>

                                <FormasPago
                                    v-model="presupuesto.metodos_pago"
                                    @total="UpdateTotalMetodosPago"
                                    :presupuesto="presupuesto"
                                    :facturas="facturas"
                                ></FormasPago>

                                <v-card style="min-width: 100%; padding: 1rem">
                                    <v-row>
                                        <v-col cols="12">
                                            <h3>Configuración extra</h3>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-file-input
                                                :readonly="readonly"
                                                id="imagen"
                                                v-model="imagen"
                                                label="Añadir imagen a presupuesto"
                                                name="imagen"
                                                required
                                            ></v-file-input>
                                            <img
                                                width="100%"
                                                style="
                                                    background-color: #dddddd;
                                                    object-fit: contain;
                                                "
                                                :src="getImage"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-checkbox
                                                :readonly="readonly"
                                                v-model="
                                                    presupuesto.mostar_financiacion
                                                "
                                                label="Mostrar financiación"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="7">
                                            <v-textarea
                                                :readonly="readonly"
                                                rows="3"
                                                label="Forma de pago"
                                                v-model="presupuesto.forma_pago"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                    <v-row> </v-row>
                                </v-card>
                            </v-form>
                        </v-tab-item>

                        <!-- Archivos -->
                        <v-tab-item>
                            <listaArchivos
                                @TransferirArchivos="TransferirArchivos"
                                v-on:delete_archivo="deleteArchivo"
                                :items="presupuesto.archivo"
                                :transferir="true"
                                @subir_file="subirArchivo"
                                @subir_file_64="subirArchivo64"
                            ></listaArchivos>
                        </v-tab-item>

                        <!-- Dibujar -->
                        <v-tab-item touchless>
                            <dibujar
                                @save="subirArchivo64"
                                :id_presupuesto="$route.query.id"
                            ></dibujar>
                        </v-tab-item>

                        <!-- Calculos -->
                        <v-tab-item>
                            <calculadora-gastos
                                :id_orden="$route.query.id"
                            ></calculadora-gastos>
                        </v-tab-item>

                        <!-- Facturas -->
                        <v-tab-item>
                            <div style="display: flex; justify-content: end">
                                <v-card
                                    elevation="2"
                                    shaped
                                    color="#851e31"
                                    width="170"
                                    height="70"
                                    class="my-5 mx-2"
                                >
                                    <v-card-text
                                        class="text-center white--text"
                                    >
                                        <p
                                            class="font-weight-bold"
                                            style="margin-bottom: -4px"
                                        >
                                            Total facturas
                                        </p>
                                        {{ total_facturas | format_precio }}
                                    </v-card-text>
                                </v-card>

                                <v-card
                                    elevation="2"
                                    shaped
                                    color="#851e31"
                                    width="170"
                                    height="70"
                                    class="my-5 mx-2"
                                >
                                    <v-card-text
                                        class="text-center white--text"
                                    >
                                        <p
                                            class="font-weight-bold"
                                            style="margin-bottom: -4px"
                                        >
                                            Total notas
                                        </p>
                                        {{ total_notas | format_precio }}
                                    </v-card-text>
                                </v-card>

                                <v-card
                                    elevation="2"
                                    shaped
                                    color="#851e31"
                                    width="170"
                                    height="70"
                                    class="my-5 mx-2"
                                >
                                    <v-card-text
                                        class="text-center white--text"
                                    >
                                        <p
                                            class="font-weight-bold"
                                            style="margin-bottom: -4px"
                                        >
                                            Facturado
                                        </p>
                                        {{ total_facturado | format_precio }}
                                    </v-card-text>
                                </v-card>

                                <v-card
                                    elevation="2"
                                    shaped
                                    color="#851e31"
                                    width="170"
                                    height="70"
                                    class="my-5 mx-2"
                                >
                                    <v-card-text
                                        class="text-center white--text"
                                    >
                                        <p
                                            class="font-weight-bold"
                                            style="margin-bottom: -4px"
                                        >
                                            Pagado
                                        </p>
                                        {{ total_pagado | format_precio }}
                                    </v-card-text>
                                </v-card>

                                <v-card
                                    elevation="2"
                                    shaped
                                    color="#851e31"
                                    width="170"
                                    height="70"
                                    class="my-5 mx-2"
                                >
                                    <v-card-text
                                        class="text-center white--text"
                                    >
                                        <p
                                            class="font-weight-bold"
                                            style="margin-bottom: -4px"
                                        >
                                            Pendiente
                                        </p>
                                        {{
                                            (presupuesto.importe - total_pagado)
                                                | format_precio
                                        }}
                                    </v-card-text>
                                </v-card>
                            </div>

                            <v-data-table
                                dense
                                :headers="headers_facturas"
                                :items="facturas"
                                disable-pagination
                                :hide-default-footer="true"
                                item-key="id"
                                class="elevation-1"
                                :sort-by="['nombre']"
                                :sort-desc="[false]"
                            >
                                <template v-slot:item.facturado="{ item }">
                                    {{ item.facturado | format_precio }}
                                </template>
                                <template v-slot:item.abonado="{ item }">
                                    {{ item.abonado | format_precio }}
                                </template>
                                <template v-slot:item.pendiente="{ item }">
                                    {{
                                        (item.facturado - item.abonado)
                                            | format_precio
                                    }}
                                </template>
                            </v-data-table>
                        </v-tab-item>

                        <!-- Ordenes -->
                        <v-tab-item>
                            <ListaOrdenes
                                :id_presupuesto="this.presupuesto.id"
                                :showFilters="true"
                            ></ListaOrdenes>
                        </v-tab-item>
                    </v-tabs>

                    <div class="d-flex flex-wrap pa-3">
                        <router-link :to="$route.meta.lista">
                            <v-btn color="red" class="white--text ma-1">
                                Cancelar
                            </v-btn>
                        </router-link>
                        <v-btn
                            v-if="!presupuesto.id"
                            :disabled="isloading"
                            color="success"
                            class="white--text ma-1"
                            @click="savePresupuesto"
                        >
                            Guardar
                        </v-btn>
                        <template v-if="presupuesto.id">
                            <v-btn
                                v-if="!readonly"
                                @click="updatePresupuesto"
                                :disabled="isloading"
                                color="success"
                                class="white--text ma-1"
                                >Actualizar</v-btn
                            >
                            <router-link
                                :to="`/${$route.meta.form}?id=${
                                    presupuesto.id
                                }&duplicar=${true}`"
                            >
                                <v-btn
                                    @click="getPresupuesto(presupuesto.id)"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text ma-1"
                                    >Duplicar</v-btn
                                >
                            </router-link>

                            <v-btn
                                @click="delete_presupuesto_dialog = true"
                                v-if="!readonly"
                                :disabled="isloading"
                                color="red"
                                class="white--text ma-1"
                                >Eliminar</v-btn
                            >
                            <a
                                :href="`/api/pdf-presupuesto/${presupuesto.id}`"
                                target="_blank"
                            >
                                <v-btn
                                    :disabled="isloading"
                                    color="info"
                                    class="white--text ma-1"
                                    >Imprimir</v-btn
                                >
                            </a>
                            <a
                                :href="`/api/pdf-presupuesto-efectivo/${presupuesto.id}`"
                                target="_blank"
                            >
                                <v-btn
                                    :disabled="isloading"
                                    color="info"
                                    class="white--text ma-1"
                                    >Imprimir nota
                                </v-btn>
                            </a>
                            <template
                                v-if="
                                    presupuesto.id_estado != 1 &&
                                    presupuesto.id_estado != 3 &&
                                    presupuesto.id_estado != 5
                                "
                            >
                                <!--v-btn
                                    @click="
                                        generarFactura(false)
                                    "
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Generar factura</v-btn
                                -->
                                <routerLink
                                    :to="`/guardar-factura?id_presupuesto=${presupuesto.id}`"
                                >
                                    <v-btn
                                        :disabled="isloading"
                                        color="success"
                                        class="white--text ma-1"
                                        >Generar factura de anticipo</v-btn
                                    >
                                </routerLink>
                                <routerLink
                                    :to="`/guardar-nota?id_presupuesto=${presupuesto.id}`"
                                >
                                    <v-btn
                                        :disabled="isloading"
                                        color="success"
                                        class="white--text ma-1"
                                        >Generar nota de anticipo</v-btn
                                    >
                                </routerLink>

                                <!--v-btn
                                    @click="
                                        generarFactura(true)
                                    "
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Generar nota
                                </v-btn-->
                            </template>
                            <template v-if="rol == 9 || rol == 1">
                                <v-btn
                                    v-if="
                                        presupuesto.id != null &&
                                        presupuesto.id_estado == 4
                                    "
                                    :to="`stepper-presupuesto?id=${$route.query.id}`"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text ma-1"
                                    >Generar obras</v-btn
                                >
                            </template>

                            <v-btn
                                v-if="presupuesto.revisado == 1"
                                @click="openEmailDialog"
                                :disabled="isloading"
                                color="secondary"
                                class="white--text ma-1"
                                >Enviar PDF</v-btn
                            >
                        </template>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="product_dialog" max-width="1500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Descripción del producto
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="linea.titulo"
                                type="text"
                                label="Título del producto"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="linea.denominacion"
                                type="text"
                                label="Denominación del producto"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-checkbox
                                v-model="linea.electrica"
                                type="text"
                                label=" Instalación eléctrica"
                            >
                            </v-checkbox>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="linea.descripcion"
                                type="text"
                                label="Descripción del producto"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="success"
                        large
                        @click="
                            addLinea();
                            product_dialog = false;
                        "
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="email_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Email
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>Indique el email a enviar</h2>
                    <v-row>
                        <v-col cols="12">
                            <dynamic-select
                                @getEstado="selectDescripcion"
                                @update="saveDescripcionesPdf"
                                @create="saveDescripcionesPdf"
                                @delete="deleteDescripcionesPdf"
                                show="titulo"
                                :estados="descripciones_pdf"
                                v-model="descripcion_email"
                            >
                                <template v-slot>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                label="Título"
                                                v-model="descripcion_pdf.titulo"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-textarea
                                                label="Descripción"
                                                v-model="
                                                    descripcion_pdf.descripcion
                                                "
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </template>
                            </dynamic-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                label="Descripción"
                                v-model="email_descripcion"
                                filled
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="email"
                                type="email"
                                label="Email"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="email_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="sendEmail()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--edit dialog-->
        <v-dialog v-model="dialog" max-width="1500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Editar línea
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <div style="display: flex">
                                <v-autocomplete
                                    v-if="editlinea.tipo_prod == 0"
                                    v-model="editlinea.id_producto"
                                    :items="productos"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Producto"
                                >
                                </v-autocomplete>
                                <v-text-field
                                    v-else
                                    v-model="editlinea.producto"
                                    type="text"
                                    label="Producto"
                                >
                                </v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.cantidad"
                                    type="number"
                                    label="Unidades"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.precio"
                                    type="number"
                                    label="Precio/Unidad"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div style="display: flex">
                                <v-text-field-comma
                                    v-model="editlinea.dcto"
                                    type="number"
                                    label="Descuento"
                                >
                                </v-text-field-comma>
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="editlinea.id_tipo_dcto"
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="editlinea.titulo"
                                type="text"
                                label="Título del producto"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="editlinea.denominacion"
                                type="text"
                                label="Denominación del producto"
                            >
                            </v-text-field>
                        </v-col>
                        <v-checkbox
                            v-model="editlinea.electrica"
                            label="Instalación eléctrica"
                        ></v-checkbox>
                        <v-col cols="12">
                            <v-textarea
                                v-model="editlinea.descripcion"
                                type="text"
                                label="Descripción del producto"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="Edit()"
                        >Modificar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteLinea()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <IncidenciaMailDialog
            v-model="incidencia_dialog"
            :presupuesto="presupuesto"
        ></IncidenciaMailDialog>
        <DeleteDialog
            @delete="deletePresupuesto"
            v-model="delete_presupuesto_dialog"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import FormasPago from "./FormasPago.vue";
import ListaOrdenes from "../../ordenesTrabajo/componentes/ListaOrdenTrabajo.vue";
import { debounce } from "../../../helpers";
import listaArchivos from "../../../components/general/listaArchivos.vue";
import Dibujar from "./Dibujar.vue";
import CalculadoraGastos from "../../ordenesTrabajo/componentes/CalculadoraGastos.vue";
import modulo_facturas from "../../../store/modulos/modulo_facturas";
import clienteSelectVue from "../../../components/general/clienteSelect.vue";
import DatosClientes from "../../clientes/componentes/DatosClientes.vue";
import IncidenciaMailDialog from "./IncidenciaMailDialog.vue";
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
import { formatPrice } from "../../../helpers";

export default {
    components: {
        listaArchivos,
        Dibujar,
        CalculadoraGastos,
        clienteSelectVue,
        ListaOrdenes,
        DatosClientes,
        IncidenciaMailDialog,
        FormasPago,
        DeleteDialog,
    },
    data() {
        return {
            delete_presupuesto_dialog: false,
            totalMetodoPago: 100,
            tab: 0,
            id_estado_original: null,
            incidencia_dialog: false,
            clientela: null,
            imagen: null,
            email_descripcion: "",

            descripcion_email: null,
            product_dialog: false,
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            required_val_0: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
                (v) => v != 0 || "El campo no puede ser 0",
            ],
            sociedades: [],
            estados: [],
            ivas: [21, 10, 4, 0],
            email_dialog: false,
            email: "",
            rol: 0,

            headers_facturas: [
                {
                    text: "N° Factura",
                    value: "nro_factura",
                    sortable: false,
                },
                {
                    text: "Facturado",
                    value: "facturado",
                    sortable: false,
                },
                {
                    text: "Abonado",
                    value: "abonado",
                    sortable: false,
                },
                {
                    text: "Pendiente",
                    value: "pendiente",
                    sortable: false,
                },
            ],
            facturas: [],
            total_facturas: 0,
            total_notas: 0,
            total_facturado: 0,
            total_pagado: 0,
            total_pendiente: 0,

            enable_iva: false,

            productos: [],

            presupuesto: {
                mudanza: 0,
                mostar_financiacion: 0,
                id_estado: 1,
                id: null,
                fecha: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                )
                    .toISOString()
                    .substr(0, 10),
                revisado: false,
                metodos_pago: [
                    {
                        id_metodo: 1,
                        monto: 100,
                        metodo: {
                            id: 1,
                            nombre: "Transferencia bancaria",
                        },
                        id_tipo_dcto: 0,
                        pagado: 0,
                        facturado: 0,
                        pendiente: 0,
                    },
                ],
                clientela: null,
                id: null,
                id_cliente: null,
                iva: 21,
                subtotal: 0,
                forma_pago: null,
                dcto: 0,
                id_tipo_dcto: 0,
                total: 0,
                lineas: [],
                lineas_deleted: [],
            },
            delete_dialog: false,
            linea: {
                id: null,
                dcto_total: 0,
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
                electrica: 0,
            },
            editlinea: {
                id_producto: null,
                producto: "",
                dcto_total: 0,
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
                electrica: 0,
            },
            dialog: false,
            init_edit: false,
            edit_index: -1,
            descripciones_pdf: [],
            descripcion_pdf: {
                id: null,
                descripcion: null,
            },
        };
    },
    watch: {
        imagen: function (val) {
            let file = document.getElementById("imagen").files[0];
            if (file != null) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                let esto = this;
                reader.onload = function () {
                    let elemento = reader.result.split(",")[1];
                    //console.log(elemento);
                    esto.presupuesto.imagen_pdf = elemento;
                };
                reader.onerror = function (error) {
                    //console.log("Error: ", error);
                };
            }
        },
        descripcion_email: function (val) {
            this.email_descripcion = this.descripciones_pdf.find(
                (element) => element.id == this.descripcion_email
            ).descripcion;
        },
        enable_iva: function (val) {
            if (!val) {
                this.presupuesto.iva = 0;
            }
            this.calcularTotalmax();
        },

        "presupuesto.iva": function (iva) {
            this.calcularTotalmax();
        },
        "presupuesto.id_tipo_dcto": function () {
            this.calcularTotalmax();
        },
        "presupuesto.dcto": function () {
            this.calcularTotalmax();
        },
        "presupuesto.mudanza": function (val) {
            this.calcularTotalmax();
        },
        "linea.id_producto": function (val) {
            this.productos.forEach((element) => {
                if (element.id == val) {
                    this.linea.producto = element.nombre.toString();
                    this.linea.precio = element.precio;
                }
            });
        },
        "editlinea.id_producto": function (val) {
            this.productos.forEach((element) => {
                if ((element.id == val) & !this.init_edit) {
                    this.editlinea.producto = element.nombre.toString();
                    //this.editlinea.precio = element.precio;
                }
                this.init_edit = false;
            });
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        nacimiento(val) {
            this.nacimientoesp = this.formatDate(this.nacimiento);
            this.cliente.nacimiento = this.nacimiento;
        },
        fecha_alta(val) {
            /*this.fecha_altaesp = this.formatDate(this.fecha_alta);
                this.cliente.fecha_alta = this.fecha_alta;*/
        },
        "presupuesto.id_cliente"(val) {
            this.presupuesto.clientela = this.clientes.find(
                (cliente) => cliente.id == val
            );
        },
    },
    created() {
        this.rol = localStorage.getItem("role");
        this.getDescripcionesPdf();
        this.getSociedades();
        this.getProductos();
        this.getEstados();
        if (this.$route.query.id) {
            this.getPresupuesto(this.$route.query.id);
            this.getFacturas();
        } else {
            if (this.$route.query.cliente) {
                this.presupuesto.id_cliente = parseInt(
                    this.$route.query.cliente
                );
                const me = this;
                axios
                    .get(`api/getcliente/${this.$route.query.cliente}`)
                    .then((res) => {
                        me.presupuesto.clientela = res.data;
                    });
            }
        }
    },
    methods: {
        // Acciones de presupuesto:
        getPresupuesto(id) {
            axios.get(`api/getpresupuesto/${id}`).then(
                (res) => {
                    this.presupuesto = res.data;
                    this.id_estado_original = this.presupuesto.id_estado;
                    if (this.presupuesto.clientela != null)
                        this.clientela = this.presupuesto.clientela;
                    if (this.$route.query.duplicar) {
                        this.presupuesto.id = null;
                    }
                    this.presupuesto.lineas_deleted = [];
                    let found = false;
                    this.presupuesto.iva = parseFloat(this.presupuesto.iva);

                    let total = 0;

                    // Actualiza el total en el store
                    this.$store.dispatch("updateTotal", total);

                    if (this.presupuesto.cliente != null) {
                        if (this.presupuesto.cliente.length > 0) {
                            this.email = this.presupuesto.cliente[0].email;
                            found = true;
                        }
                    }
                    if (!found) {
                        this.$store.dispatch("getClientes", {
                            rol: this.$route.meta.rol,
                        });
                    }
                    if (
                        Number.parseFloat(this.presupuesto.iva.toString()) != 0
                    ) {
                        this.enable_iva = true;
                    }
                },
                (res) => {}
            );
        },
        savePresupuesto() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            // console.log(this.totalMetodoPago);
            if (this.totalMetodoPago <= 99 || this.totalMetodoPago >= 101) {
                this.$custom_error(
                    "La suma de los porcentajes en métodos de pago debe tener un total del 100%"
                );
                return;
            }
            this.presupuesto.id_sociedad = 6;
            axios
                .post("api/save-presupuesto", this.presupuesto)
                .then((res) => {
                    this.$toast.sucs("Presupuesto guardado con éxito");
                    this.presupuesto = res.data;
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        async updatePresupuesto() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            axios
                .post("api/update-presupuesto", this.presupuesto)
                .then((res) => {
                    this.presupuesto = res.data;
                    this.$toast.sucs("Presupuesto guardado con éxito");
                    if (
                        this.presupuesto.id_estado != this.id_estado_original &&
                        this.presupuesto.id_estado == 14
                    ) {
                        this.incidencia_dialog = true;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deletePresupuesto() {
            axios
                .post("api/delete-presupuesto", {
                    id: this.presupuesto.id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Presupuesto eliminado con éxito");
                        this.$router.push(this.$route.meta.lista);
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el presupuesto");
                    }
                );
            this.getPresupuestos();
        },
        UpdateTotalMetodosPago(val) {
            this.totalMetodoPago = val;
            // console.log("Total Actualizado", val);
        },

        // acciones de lineas de presupuesto
        openDescripcion() {
            if (!this.$refs.linea_form.validate()) return;
            const producto = this.productos.find(
                (element) => element.id == this.linea.id_producto
            );
            this.linea.descripcion = producto.descripcion;
            this.linea.titulo = producto.nombre;
            this.linea.denominacion = producto.nombre;

            this.product_dialog = true;
        },
        addLinea() {
            this.calcularTotal(this.linea);
            this.presupuesto.lineas.push(this.linea);

            this.emptyLinea();
            this.calcularTotalmax();
        },
        openEditDialog(item) {
            this.editlinea = JSON.parse(JSON.stringify(item));
            this.editlinea.id_tipo_dcto = this.editlinea.tipo_dcto;

            this.dialog = true;
            this.init_edit = true;
            this.edit_index = this.presupuesto.lineas.indexOf(item);
        },
        Edit() {
            let items = JSON.parse(JSON.stringify(this.editlinea));
            this.presupuesto.lineas[this.edit_index] = items;
            const lineas = JSON.parse(JSON.stringify(this.presupuesto.lineas));
            this.presupuesto.lineas = [];
            this.presupuesto.lineas = lineas;
            this.calcularTotal(this.presupuesto.lineas[this.edit_index]);
            this.editlinea = {
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
                electrica: 0,
            };
            this.closeDialog();
            this.calcularTotalmax();
        },
        openDeleteDialog(item) {
            this.editlinea = item;
            this.delete_dialog = true;
        },
        deleteLinea() {
            let index = this.presupuesto.lineas.indexOf(this.editlinea);
            if (this.editlinea.id != null) {
                this.presupuesto.lineas_deleted.push(this.editlinea.id);
            }
            this.presupuesto.lineas.splice(index, 1);
            this.delete_dialog = false;
            this.calcularTotalmax();
        },
        closeDialog() {
            this.delete_dialog = false;
            this.dialog = false;
        },
        emptyLinea() {
            this.linea = {
                id: null,
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
                electrica: 0,
            };
            this.$refs.linea_form.reset();
        },

        // Acciones del boton "enviar PDF"
        openEmailDialog() {
            this.email_dialog = true;
        },
        closeEmailDialog() {
            this.email_dialog = false;
        },
        selectDescripcion(id) {
            this.descripcion_pdf = this.descripciones_pdf.find(
                (element) => element.id == id
            );
            if (this.descripcion_pdf == null) {
                this.descripcion_pdf = {
                    id: null,
                    descripcion: null,
                };
            }
        },
        saveDescripcionesPdf() {
            axios
                .post("api/save-descripcion-pdf", this.descripcion_pdf)
                .then((res) => {
                    this.descripciones_pdf = res.data;
                    this.descripcion_pdf = {
                        id: null,
                        titulo: null,
                        descripcion: null,
                    };
                });
        },
        deleteDescripcionesPdf(id) {
            axios.get(`api/delete-descripcion-pdf/${id}`).then((res) => {
                this.descripciones_pdf = res.data;
            });
        },
        sendEmail() {
            axios
                .post(`api/sendEmailPresupuesto`, {
                    email: this.email,
                    id: this.presupuesto.id,
                    descripcion: this.email_descripcion,
                })
                .then((res) => {
                    this.email_dialog = false;
                    this.$custom_success("Correo enviado con éxito");
                });
        },

        // Generar factura a partir del presupuesto
        generarFactura(nota) {
            let cliente = this.presupuesto.clientela;
            if (cliente == null || cliente?.id != this.presupuesto.id_cliente) {
                cliente = this.clientes.find(
                    (ele) => ele.id == this.presupuesto.id_cliente
                );
            }
            let factura = {
                id_cliente: this.presupuesto.id_cliente,
                id_metodo_pago: 1,
                id_serie: 1,
                id_sociedad: null,
                id_presupuesto: this.presupuesto.id,
                iva: 21,
                manual: 1,
                observaciones: `${nota ? "Nota" : "Factura"} de presupuesto`,
                lineas: [],
                total: this.razonChiguire(this.calcularSubTotal(), nota),
                totalAbono: 0,
                cliente: cliente,
            };
            this.presupuesto.lineas.forEach((linea) => {
                const subtotal = this.razonChiguire(linea.total, nota);
                let dcto =
                    this.presupuesto.id_tipo_dcto == 0
                        ? (subtotal * this.presupuesto.dcto) / 100
                        : this.presupuesto.dcto /
                          (this.presupuesto.lineas.length +
                              (this.presupuesto.mudanza ? 1 : 0));
                const total = subtotal - dcto;
                factura.lineas.push({
                    id_producto: linea.id_producto,
                    articulo: linea.denominacion,
                    cantidad: linea.cantidad,
                    precio: this.razonChiguire(
                        linea.total / linea.cantidad,
                        nota
                    ),
                    dcto: dcto,
                    descripcion: linea.denominacion,

                    subtotal: subtotal,
                    total: total,
                });
            });
            if (this.presupuesto.mudanza) {
                const subtotal = this.razonChiguire(
                    this.presupuesto.mudanza,
                    nota
                );
                let dcto =
                    this.presupuesto.id_tipo_dcto == 0
                        ? (subtotal * this.presupuesto.dcto) / 100
                        : this.presupuesto.dcto /
                          (this.presupuesto.lineas.length +
                              (this.presupuesto.mudanza ? 1 : 0));
                const total = subtotal - dcto;
                factura.lineas.push({
                    id_producto: null,
                    articulo: "Plataforma de mudanza",
                    cantidad: 1,
                    precio: this.razonChiguire(this.presupuesto.mudanza, nota),
                    dcto: dcto,
                    descripcion: "Plataforma de mudanza",

                    subtotal: subtotal,
                    total: total,
                });
            }
            this.$store.dispatch("setFactura", factura);

            this.$router.push(`guardar-${nota ? "nota" : "factura"}`);
        },

        // Genrar orden de trabajo a partir de las lineas del presupuesto
        generarOrdenes() {
            if (this.presupuesto.id) {
                axios
                    .post("api/ordenes-from-presupuesto", {
                        id: this.presupuesto.id,
                    })
                    .then((res) => {
                        this.$custom_success("Órdenes generadas con éxito");
                    });
            }
        },

        // Metodos auxiliares
        razonChiguire(numero, nota) {
            let total = 0;

            this.presupuesto.metodos_pago.forEach((element) => {
                let monto = element.monto;
                if (element.id_tipo_dcto == 1) {
                    monto = (element.monto / this.presupuesto.total) * 100;
                }

                if (element.id_metodo != 3) {
                    if (!nota) total += parseFloat(monto);
                } else {
                    if (nota)
                        total +=
                            parseFloat(monto) /
                            (1 + this.presupuesto.iva / 100);
                }
            });
            if (total == 0) {
                return numero;
            } else {
                return (parseFloat(numero) * total) / 100;
            }
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        CalculateDescuento() {
            if (this.presupuesto.id_tipo_dcto == 1) {
                return this.presupuesto.dcto;
            } else {
                return this.calcularSubTotal() * (this.presupuesto.dcto / 100);
            }
        },
        CalcularTotalDcto(item) {
            return item.precio * item.cantidad - item.total;
        },
        calcularSubTotal() {
            let total = 0;
            this.presupuesto.lineas.forEach((element) => {
                total += +element.total;
            });
            if (!isNaN(parseFloat(this.presupuesto.mudanza)))
                total += parseFloat(this.presupuesto.mudanza);
            return total;
        },
        calcularTotalmax() {
            this.presupuesto.total =
                (this.calcularSubTotal() - this.CalculateDescuento()) *
                (1 + this.presupuesto.iva / 100);
        },
        CalcularSubTotales(lineas) {
            let total = 0;
            lineas.forEach((element) => {
                total += parseFloat(element.total);
            });
            /*             if (!isNaN(parseFloat(this.presupuesto.mudanza))) {
                total += parseFloat(this.presupuesto.mudanza);
            } */

            return total;
        },
        calcularTotal(linea) {
            linea.total = linea.precio * linea.cantidad;
            if (linea.id_tipo_dcto == 0) {
                linea.total *= 1 - linea.dcto / 100;
            } else if (linea.total > linea.dcto) {
                linea.total -= linea.dcto;
            } else {
                linea.total = 0;
            }
            linea.total = linea.total.toFixed(2);
        },

        // Acciones del tab "Archivos"
        TransferirArchivos(archivos_id) {
            axios
                .post(`api/asignar-archivo`, {
                    archivos: archivos_id,
                    id_presupuesto: this.presupuesto.id,
                })
                .then(
                    (res) => {
                        this.presupuesto.archivo = res.data;
                    },
                    (res) => {
                        this.$toast.error("Error al eliminar el archivo");
                    }
                );
        },
        subirArchivo64(data) {
            let me = this;
            axios
                .post(`api/save-archivo64-presupuesto`, {
                    id: this.presupuesto.id,
                    archivo: data.data,
                    nombre: data.nombre,
                    extension: data.extension,
                })
                .then((res) => {
                    me.presupuesto.archivo = res.data;
                    this.$toast.sucs("Archivo guardado con éxito");
                    data.callback();
                });
        },
        subirArchivo(archivo) {
            let me = this;
            archivo.append("id", this.presupuesto.id);
            axios.post(`api/save-archivo-presupuesto`, archivo).then((res) => {
                me.presupuesto.archivo = res.data;
            });
        },
        deleteArchivo(archivo) {
            axios.get(`api/deletearchivo/${archivo.id}`).then(
                (res) => {
                    this.presupuesto.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },

        // Metodos generales
        getDescripcionesPdf() {
            axios.get("api/get-descripciones-pdf").then((res) => {
                this.descripciones_pdf = res.data;
            });
        },
        getSociedades() {
            axios.get("api/get-sociedades").then((res) => {
                this.sociedades = res.data;
            });
        },
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        getEstados() {
            axios.get("api/get-estados-presupuestos").then((res) => {
                this.estados = res.data;
            });
        },
        getFacturas() {
            const id_presupuesto = this.$route.query.id;
            axios
                .get(
                    `api/get-facturas-presupuesto?id_presupuesto=${id_presupuesto}`
                )
                .then(
                    (res) => {
                        let response = res.data.success;
                        this.facturas = response.facturas;
                        this.total_facturas = response.total_facturas;
                        this.total_notas = response.total_notas;
                        this.total_facturado = response.total_facturado;
                        this.total_pagado = response.total_pagado;
                        this.total_pendiente = response.total_pendiente;
                    },
                    (res) => {}
                );
        },

        // Metodos en desuso
        openEditPDFDialog(id) {
            this.descripcion_pdf = this.descripciones_pdf.find(
                (element) => element.id == id
            );
        },
        getClientes() {
            axios.get(`api/get-clientes/-1`).then(
                (res) => {
                    this.clientes = res.data.data;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.agentes = res.data.Agentes;
                },
                (res) => {}
            );
        },
        Validar() {
            axios
                .post("api/validate-contrato", {
                    id: this.$route.query.id,
                })
                .then((res) => {
                    this.$router.go();
                });
        },
        PresupuestoToContrato() {
            axios
                .post("api/PresupuestoToContrato", {
                    id: this.presupuesto.id,
                })
                .then((res) => {
                    this.$router.push(`guardar-contrato?id=${res.data.id}`);
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },

        formatPrice,

        /*formatNumber(number) {
            return Number.parseFloat((number ?? 0).toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },*/
    },
    filters: {},

    computed: {
        headers() {
            return [
                {
                    text: "Título",
                    value: "titulo",
                    sortable: false,
                },
                {
                    text: "Denominación",
                    value: "denominacion",
                    sortable: false,
                },
                {
                    text: "Descripción",
                    value: "producto",
                    sortable: false,
                },
                {
                    text: "Unidades",
                    value: "cantidad",
                    sortable: false,
                },
                {
                    text: "Precio/Unidad",
                    value: "precio",
                    sortable: false,
                },
                {
                    text: "Subtotal",
                    value: "pvp",
                    sortable: false,
                },
                {
                    text: "Descuento",
                    value: "dcto_total",
                    sortable: false,
                },
                {
                    text: "Total",
                    value: "total",
                    sortable: false,
                },
                ...(!this.readonly
                    ? [
                          {
                              text: "Acciones",
                              value: "action",
                              sortable: false,
                          },
                      ]
                    : []),
            ];
        },
        readonly() {
            return (
                [2, 4, 8, 9].includes(
                    parseInt(this.presupuesto.id_estado_original)
                ) &&
                !this.presupuesto.editable &&
                ![1, 8, 9].includes(parseInt(this.rol))
            );
        },
        productos_lineas() {
            let result = [];
            let producto_lineas = {};
            this.presupuesto.lineas.forEach((linea) => {
                if (producto_lineas[linea.id_producto] == null) {
                    const producto = this.productos.find(
                        (value) => linea.id_producto == value.id
                    );

                    producto_lineas[linea.id_producto] = producto ?? {};
                    producto_lineas[linea.id_producto].lineas = [];
                    result.push(producto_lineas[linea.id_producto]);
                }
                if (producto_lineas[linea.id_producto] != null)
                    producto_lineas[linea.id_producto].lineas.push(linea);
            });
            // console.log(producto_lineas);
            return producto_lineas;
        },
        getImage() {
            if (this.imagen != null) {
                return URL.createObjectURL(this.imagen);
            } else {
                return `api/get-presupuesto-image/${this.$route.query.id}`;
            }
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        clientes() {
            let clientes_temp = this.$store.getters.getclientes;
            if (this.clientela != null) {
                clientes_temp.push(this.clientela);
            }
            return clientes_temp;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}

.spacing {
    padding-top: 0 !important;
}
</style>
